import { createReducer, on } from '@ngrx/store';
import { Organization } from '@shared/types/organization.model';
import {
  clearOrganizationState,
  loadOrganizations,
  loadOrganizationsFailure,
  loadOrganizationsSuccess,
  selectOrganization,
} from './organization.actions';

export const organizationFeatureKey = 'organization';

export interface OrganizationState {
  organizations: Organization[];
  loading: boolean;
  error: string | null;
  selectedOrganizationId: string | null;
}

export const initialOrganizationState: OrganizationState = {
  organizations: [],
  loading: false,
  error: null,
  selectedOrganizationId: null,
};

export const organizationReducer = createReducer(
  initialOrganizationState,
  on(loadOrganizations, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadOrganizationsSuccess, (state, { organizations }) => ({
    ...state,
    organizations,
    loading: false,
    error: null,
  })),
  on(loadOrganizationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(selectOrganization, (state, { organizationId }) => ({
    ...state,
    selectedOrganizationId: organizationId,
  })),
  on(clearOrganizationState, () => initialOrganizationState)
);
